import { loadHermesData } from 'ha/modules/Hermes';

const getCityCountry =
  (store, getComponentsWithNotFound) => (nextState, callback) => {
    store
      .dispatch(loadHermesData(nextState.location.pathname))
      .then(() => getComponentsWithNotFound('Cities')(nextState, callback));
  };

export { getCityCountry };
